export default __webpack_public_path__ + "static/bsc-238b2cdff7881ff475974cf21438adf0.svg";